/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Text, TextBlock } from 'sarsaparilla';

function DisclaimerStep() {
    return (
        <div className="wizard-disclaimer-step">
            <TextBlock>
                <Text fontWeight="semibold" className="mb-2">
                    Each America the Beautiful Pass is issued to one person (the pass
                    holder) who must be present, with valid photo identification, each
                    time the pass is used.
                </Text>
                <Text>
                    Passes cover entrance or standard amenity (day-use) fees to thousands
                    of federal recreational lands.
                </Text>
                <ul>
                    <li>
                        For locations that charge fees{' '}
                        <Text fontWeight="semibold" tag="span">
                            per vehicle
                        </Text>
                        , an America the Beautiful Pass admits the pass holder and
                        passengers in a non-commercial vehicle.
                    </li>
                    <li>
                        For locations that charge fees{' '}
                        <Text fontWeight="semibold" tag="span">
                            per person
                        </Text>
                        , an America the Beautiful Pass admits the pass holder plus 3
                        adults (16 and older), not to exceed 4 adults.
                    </li>
                </ul>
                <Text>
                    As you proceed, please consider if anyone traveling with you already
                    has or is eligible for one of the free or discounted passes.
                </Text>
                <ul>
                    <li>
                        If another person already has a pass, it will cover fees as
                        described above.
                    </li>
                    <li>
                        If another person is eligible for one of the passes, they will
                        need to create or log in to their own {process.env.SITE_NAME}{' '}
                        account to get the pass. The name on the digital pass must match
                        the name on the {process.env.SITE_NAME} account, unless stated
                        otherwise.
                    </li>
                </ul>
            </TextBlock>
        </div>
    );
}

export default DisclaimerStep;
